import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import HelloCity from "../../assets/img/hello_city.svg";
import { RiSlideshow2Line } from 'react-icons/ri';
import { FaRegListAlt, FaStreetView, FaUsers, FaGlobe } from 'react-icons/fa';
import { MdOutlinePayment, MdRealEstateAgent } from 'react-icons/md';
import { BsQuestionOctagon } from 'react-icons/bs';
import { HiOutlineViewGridAdd } from 'react-icons/hi';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";

const Dashboard = () => {
  const navigate = useNavigate()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    document.title = "Island Luxury - Dashboard"
		if(!userInfo) {
			navigate("/");
		} 
    else {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo?.token}`
        }
      }
      const getUser = async () => {
        const res = await axios.get(baseUrl + "/api/v1/auth/profile", config)
        localStorage.setItem("profile", JSON.stringify(res.data.user))
      }
      getUser()
    }
	}, [userInfo, navigate])

  return (
    <div id="dashboard">
      <Header />
      <main className="container">
        <section>
          <div className="welcome-area">
            <img src={HelloCity} alt="Hello User" />
            <div className="welcome-note">
              <h2>Welcome, {userInfo?.firstname}</h2>
              <p>What will you like to do today?</p>
            </div>
          </div>
        </section>
        <section className="menu-grid">
          {userInfo?.role === "admin" && 
            <>
              <NavLink to="/all-agents" className="menu-card">
                <FaUsers size={40} />
                <h3>Agents</h3>
                <p>All registered agents</p>
              </NavLink>
              <NavLink to="/properties" className="menu-card">
                <MdRealEstateAgent size={40} />
                <h3>Properties</h3>
                <p>View & approve properties</p>
              </NavLink>
              {/* <NavLink to="/subscriptions" className="menu-card">
                <MdOutlinePayment size={40} />
                <h3>Subscriptions</h3>
                <p>View & approve subscriptions</p>
              </NavLink> */}
              <NavLink to="/requests" className="menu-card">
                <BsQuestionOctagon size={40} />
                <h3>View Requests</h3>
                <p>View Property Requests</p>
              </NavLink>
            </>
          }
          {userInfo?.role === "estate-agent" && 
            <>
              <NavLink to="/add-property" className="menu-card">
                <HiOutlineViewGridAdd size={40} />
                <h3>Post Property</h3>
                <p>Post properties</p>
              </NavLink>
              <NavLink to="/my-listing" className="menu-card">
                <FaRegListAlt size={40} />
                <h3>My Listing</h3>
                <p>Add, edit & delete your property</p>
              </NavLink>
              {/* <NavLink to="/plans" className="menu-card">
                <MdOutlinePayment size={40} />
                <h3>Subscription</h3>
                <p>Suscribe or update current account</p>
              </NavLink> */}
              {/* <NavLink to="#" className="menu-card">
                <FaStreetView size={40} />
                <h3>My Page</h3>
                <p>View your dedicated webpage as a visitor</p>
              </NavLink> */}
              {/* <NavLink to="#" className="menu-card">
                <RiSlideshow2Line size={40} />
                <h3>Banner Adverts</h3>
                <p>Subscribe to have your banner adverts on Island Luxury Property Listings</p>
              </NavLink> */}
            </>
          }
          <NavLink to="/" className="menu-card">
            <FaGlobe size={40} />
            <h3>Home</h3>
            <p>Navigate back to the Home page</p>
          </NavLink>
        </section>
      </main>
    </div>
  )
}

export default Dashboard;